"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _context = require("../../context");
var _layout = require("../../layout");
var _utils2 = require("../../utils");
var _constants = require("../constants");
var _constants2 = require("./constants");
const BoxContainer = (0, _context.styledWithTheme)(_layout.Col)(_ref => {
  let {
    disabled,
    error,
    theme: {
      isInHighContrast
    }
  } = _ref;
  let backgroundColor;
  let borderColor;
  let checkedBorderColor;
  let interactiveStyles = {};
  if (disabled) {
    backgroundColor = (0, _utils.token)('color.input.bg-disabled');
    if (isInHighContrast) {
      borderColor = checkedBorderColor = _utils2.WHCM_DISABLED_ITEM_COLOR;
    } else {
      if (error) {
        borderColor = (0, _utils.token)('color.status.critical-border-disabled');
        checkedBorderColor = (0, _utils.token)('color.input.selected.critical-bg-disabled');
      } else {
        borderColor = (0, _utils.token)('color.input.border-disabled');
        checkedBorderColor = (0, _utils.token)('color.input.selected.border-disabled');
      }
    }
  } else {
    backgroundColor = (0, _utils.token)('color.input.bg-default');
    let hoverColor;
    if (error) {
      borderColor = (0, _utils.token)('color.status.critical-border-default');
      checkedBorderColor = (0, _utils.token)('color.status.critical-border-default');
      hoverColor = (0, _utils.token)('color.status.critical-border-hover');
    } else {
      borderColor = (0, _utils.token)('color.input.border-default');
      checkedBorderColor = (0, _utils.token)('color.input.selected.border-default');
      hoverColor = (0, _utils.token)('color.input.border-hover');
    }
    interactiveStyles = {
      ':hover': {
        borderColor: "".concat(hoverColor, "!important")
      },
      ':has(:focus-visible)': {
        outline: "".concat((0, _utils2.px)(_constants.OUTLINE_BORDER_WIDTH), " solid ").concat((0, _utils.token)('color.border.border-focus')),
        outlineOffset: 1
      }
    };
  }
  const padding = (0, _utils.token)('dimensions.spacing.300');
  return {
    color: (0, _utils.token)(disabled ? 'color.text.disabled' : 'color.text.primary'),
    gap: (0, _utils.token)('dimensions.spacing.200'),
    flex: 1,
    height: '100%',
    justifyContent: 'flex-start',
    border: "".concat(_constants2.BOX_CONTAINER_BORDER_WIDTH, " solid ").concat(borderColor),
    padding,
    borderRadius: (0, _utils.token)('dimensions.border.radius.300'),
    backgroundColor,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'border-color 0.1s, backgroundColor 0.1s, box-shadow 0.1s',
    ':has(input:checked)': {
      border: "".concat(_constants2.BOX_CONTAINER_SELECTED_BORDER_WIDTH, " solid ").concat(checkedBorderColor),
      padding: "calc(".concat(padding, " - ").concat(_constants2.BOX_CONTAINER_SELECTED_BORDER_WIDTH, " + ").concat(_constants2.BOX_CONTAINER_BORDER_WIDTH, ")")
    },
    // Images inside of DetailedBox should be rounded.
    img: {
      borderRadius: (0, _utils.token)('dimensions.border.radius.100')
    },
    ...interactiveStyles
  };
});
var _default = exports.default = BoxContainer;